import * as React from "react"
import {
  Heading,
  Stack,
  Button,
  Link,
} from '@chakra-ui/react';
import {
  Link as GatsbyLink,
} from 'gatsby';

export default function PhoneCTA() {

  return (
    <Stack direction={{ base: 'column', lg: 'row' }} alignItems='center'>
      <Stack w={'full'} textAlign={'center'}>
        <Heading as='h3' size='lg'>
          {`Contact us for a free estimate or call:`}
          <div style={{paddingTop: '20px'}}>
            <a href="tel:+18562520870" target='_blank' rel="noopener nofollow noreferrer">{`(856) 252-0870`}</a>
          </div>
        </Heading>
        <Stack direction={{ base: 'column', md: 'row' }} spacing={4} style={{margin: '30px auto 0 auto'}}>
          <Button
            fontFamily={'PoppinsMedium, sans-serif, serif'}
            fontWeight={'normal'}
            fontSize={'20px'}
            rounded={'full'}
            bg={'#7B4B94'}
            color={'white'}
            size='lg'
            _hover={{
            bg: '#582e6e',
            }}>
            <Link as={GatsbyLink} to='/contact' _hover={{textDecoration: 'none'}}>Get a Quote</Link>
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}